var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 8.42765H14.4286L12.9429 7.31297C12.3886 6.89568 11.6114 6.89568 11.0571 7.31297L9.57143 8.42765H8.28571C7.57714 8.42765 7 9.005 7 9.71383C7 10.4227 7.57714 11 8.28571 11H15.7143C16.4229 11 17 10.4227 17 9.71383C17 9.005 16.4229 8.42765 15.7143 8.42765ZM11.5714 7.99893C11.8229 7.81029 12.1771 7.81029 12.4286 7.99893L13 8.42765H11L11.5714 7.99893ZM15.7143 10.1426H8.28571C8.05143 10.1426 7.85714 9.9482 7.85714 9.71383C7.85714 9.47946 8.05143 9.2851 8.28571 9.2851H15.7143C15.9486 9.2851 16.1429 9.47946 16.1429 9.71383C16.1429 9.9482 15.9486 10.1426 15.7143 10.1426Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.652 12.0061C15.4258 11.9661 15.2161 12.1262 15.1775 12.3607L14.5816 16.0726C14.4823 16.696 13.9691 17.1478 13.3567 17.1478H10.642C10.0351 17.1478 9.51642 16.696 9.4171 16.0726L8.8212 12.3607C8.78258 12.1262 8.56739 11.9718 8.34669 12.0061C8.12047 12.0462 7.97149 12.2692 8.0046 12.498L8.6005 16.2098C8.76602 17.2508 9.62677 18 10.642 18H13.3567C14.3719 18 15.2326 17.245 15.3982 16.2098L15.9941 12.498C16.0327 12.2635 15.8782 12.0462 15.652 12.0061Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6784 14.9954C10.6784 14.9954 10.7128 14.9954 10.7299 14.9954C10.9062 14.9631 11.0222 14.783 10.9964 14.5984L10.6397 12.2901C10.6096 12.1008 10.4463 11.9761 10.2701 12.0038C10.0938 12.0362 9.97779 12.2162 10.0036 12.4009L10.3603 14.7092C10.3861 14.88 10.5236 15 10.6784 15V14.9954Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.322 15C13.4764 15 13.6137 14.88 13.6394 14.7093L13.9954 12.4018C14.0254 12.2126 13.9053 12.0373 13.7295 12.005C13.5536 11.9726 13.3906 12.1019 13.3606 12.2911L13.0046 14.5985C12.9746 14.7877 13.0947 14.9631 13.2705 14.9954C13.2877 14.9954 13.3048 14.9954 13.322 14.9954V15Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4c63d262.svg";
export { ForwardRef as ReactComponent };